"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stepper = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../_util/config-context");
exports.Stepper = react_1.default.forwardRef(function Stepper(_a, ref) {
    var _b;
    var type = _a.type, steps = _a.steps, current = _a.current, readonly = _a.readonly, nowrap = _a.nowrap, className = _a.className, props = tslib_1.__rest(_a, ["type", "steps", "current", "readonly", "nowrap", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    var stepperClassName = classnames_1.default((_b = {},
        _b[classPrefix + "-step"] = true,
        _b[classPrefix + "-step--vertical-new"] = type === "vertical",
        _b[classPrefix + "-step--alternative"] = type === "process",
        _b[classPrefix + "-step--vertical"] = type === "process-vertical",
        _b[classPrefix + "-step--dot"] = type === "process-vertical-dot",
        _b[classPrefix + "-step--readonly"] = readonly,
        _b[classPrefix + "-step--wrap-normal"] = nowrap,
        _b[className] = className,
        _b));
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: stepperClassName }, props), steps.map(function (step, index, steps) { return (react_1.default.createElement("div", { key: step.id, className: classnames_1.default(classPrefix + "-step__item", step.className, {
            "is-current": !readonly && step.id === current,
        }), style: step.style },
        react_1.default.createElement("div", { className: classPrefix + "-step__num" }, index + 1),
        react_1.default.createElement("div", { className: classPrefix + "-step__content" },
            react_1.default.createElement("div", { className: classPrefix + "-step__title" }, step.label),
            step.detail && (react_1.default.createElement("div", { className: classPrefix + "-step__description" }, step.detail))),
        step.tip && (react_1.default.createElement("div", { className: classPrefix + "-step__tips" }, step.tip)),
        index < steps.length - 1 && (react_1.default.createElement("div", { className: classPrefix + "-step__arrow" })))); })));
});
exports.Stepper.displayName = "Stepper";
//# sourceMappingURL=Stepper.js.map